import { Flex, FlexProps } from '@chakra-ui/react'
import { ScreenContext, useContentWidth } from '@hb/react'
import { PropsWithChildren, useContext } from 'react'
import { PublicFooter } from './PublicFooter'

const Wrapper = ({
  children,
  fullHeight,
  noFooter,
  ...props
}: PropsWithChildren<FlexProps & { fullHeight?: boolean; noFooter?: boolean }>) => {
  if (fullHeight)
    return (
      <Flex
        w="100%"
        align="center"
        transition="opacity 500ms"
        h="100%"
        overflow="hidden"
        direction="column"
        {...props}>
        {children}
        {noFooter ? null : <PublicFooter />}
      </Flex>
    )
  return (
    <Flex w="100%" h="100%" overflowY="auto" flexFlow="column">
      <Flex w="100%" direction="column" align="center" transition="opacity 500ms" {...props}>
        {children}
      </Flex>
      {noFooter ? null : <PublicFooter />}
    </Flex>
  )
}

export const PageContainer = ({
  children,
  fullWidth,
  fullHeight,
  pb = 2,
  contentProps,
  contentMaxWidth = 1200,
  noFooter,
  ...props
}: FlexProps & {
  fullWidth?: boolean
  fullHeight?: boolean
  contentMaxWidth?: number
  pb?: number
  contentProps?: FlexProps
  noFooter?: boolean
}) => {
  const { width } = useContext(ScreenContext)
  const contentWidth = useContentWidth(width, contentMaxWidth)
  return (
    <Wrapper fullHeight={fullHeight} noFooter={noFooter} {...props}>
      <Flex
        align="center"
        flexFlow="column"
        pt={4}
        pb={pb}
        px={[2, 6, 8]}
        position="relative"
        w="100%"
        maxW={`${contentMaxWidth}px`}
        minH="0"
        flex={fullHeight ? 1 : 'unset'}
        // h={fullHeight ? '100%' : 'unset'}
        width={`${fullWidth ? width : contentWidth}px`}
        {...contentProps}>
        {children}
      </Flex>
    </Wrapper>
  )
}
